export default {
      id: "oc-res-k8s-job-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-k8s-job",
      toString: function () {
        return this.url;
      }
    }